export const breakpoints = {
  350: {
    slidesPerView: 1,
  },
  900: {
    slidesPerView: 1,
  },
  1100: {
    slidesPerView: 2,
  },
  1500: {
    slidesPerView: 3,
  },
  1900: {
    slidesPerView: 4,
  },
  2300: {
    slidesPerView: 5,
  },
};
